import { render } from "./G.vue?vue&type=template&id=ddda4b46"
import script from "./G.vue?vue&type=script&lang=js"
export * from "./G.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__